import { updateElements } from "../utils/updateElements";

document.addEventListener("cart:change", async () => {
  await updateElements(["product-card"]);
});
